import script from "./MobileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileCard.vue?vue&type=script&setup=true&lang=js"

import "./MobileCard.vue?vue&type=style&index=0&id=02f1768e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02f1768e"]])

export default __exports__